<template>
  <div class="filter-checkboxes">
    <div class="custom-control custom-checkbox" v-for="term in terms" :key="term.value">
      <input
        class="custom-control-input"
        type="checkbox"
        v-model="selected"
        :value="term.value"
        :disabled="term.count === 0 && selected.indexOf(term.value) === -1"
        :id="`checkbox-${_uid}-${term.value}`"
      >
      <label class="custom-control-label d-flex align-items-center justify-content-between" :for="`checkbox-${_uid}-${term.value}`">
        <span class="mr-2">{{ term.label }}</span>
        <small v-if="enableCount" class="filter-bucket-size font-weight-bold">{{ term.count }}</small>
      </label>
    </div>
  </div>
</template>

<script>
  import FilterTerms from './filter-terms.vue'

  export default {
    extends: FilterTerms,
    props: {
      enableCount: {
        type: Boolean,
        default: true,
      }
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .filter-checkboxes {
    .custom-checkbox {
      padding-top: .2em;
      padding-bottom: .2em;
      &:hover {
        background-color: $gray-100;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-checkboxes.vue